import { render } from "./userProfileContent.vue?vue&type=template&id=685981a6&scoped=true"
import script from "./userProfileContent.vue?vue&type=script&lang=js"
export * from "./userProfileContent.vue?vue&type=script&lang=js"

import "./userProfileContent.vue?vue&type=style&index=0&id=685981a6&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685981a6"]])

export default __exports__